/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  width: auto;
  padding: 18px 25px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.blue};
  font-weight: bold;
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: ${(props) => props.theme.colors.blue};
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Separator = styled.div`
  width: 100%;
  border-top: 1px dashed ${({ theme }) => theme.colors.lightGray};
  margin-top: 26px;
  margin-bottom: 17px;
`;

export const ExpirationDate = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
`

export const StatusContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 640px) {
    flex-wrap: wrap;
    margin-top: 5px;
  }
`;

export const StatusRadial = styled.input``;

export const StatusText = styled.span`
  color: #b4b4b4;
  font-size: 13px;
  margin-left: 10px;
  @media (max-width: 640px) {
    margin-left: 6px;
  }
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 18px;
  display: block;
  margin-bottom: 15px;
`;

export const PeriodContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 1;
  @media (max-width: 640px) {
    flex-wrap: wrap;
  }
`;

export const PeriodItem = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 14px 9px;
  border-radius: 3px;
  background-color: transparent;
  border: 1px
    ${(props) =>
      props.selected ? `dashed ${props.theme.colors.blue}` : 'solid #C1C1C1'};
  cursor: pointer;
  transition: 0.1s;
  color: ${(props) => (props.selected ? props.theme.colors.blue : '#C1C1C1')};
  margin-right: 8px;
  &:hover {
    opacity: 0.9;
  }
  @media (max-width: 640px) {
    margin-top: 5px;
  }
`;

export const PeriodCircle = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: ${(props) =>
    props.selected ? props.theme.colors.blue : '#C1C1C1'} !important;
  margin-right: 6px;
`;

export const PeriodText = styled.span`
  font-size: 12px;
  text-align: center;
  margin-top: 3px;
`;

export const DateContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 640px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const DateItem = styled.div`
  width: 270px;
`;

export const CalendarIcon = styled.span`
  width: 18px;
  color: #c1c1c1;
  font-size: 20px;
  cursor: pointer;
`;

export const FilterButtonContainer = styled.button`
  width: 270px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 5px;
  transition: 0.3s;
  border: 0px;
  color: white;
  &:hover {
    opacity: 70%;
  }

  &:hover {
    opacity: 70%;
  }

  @media (max-width: 640px) {
    margin-top: 10px;
  }
`;

export const CancelButtonContainer = styled.button`
  width: 270px;
  padding: 14px;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: 5px;
  transition: 0.3s;
  color: ${({ theme }) => theme.colors.blue};
  &:hover {
    opacity: 70%;
  }
`;

export const FilterButtonText = styled.span`
  font-size: 15px;
  font-weight: bold;
`;

export const StatusItem = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
